import { inject, provideAppInitializer } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export function provideUiIcons() {
  return provideAppInitializer(() => {
    const iconRegistry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);

    iconRegistry.addSvgIconSetInNamespace(
      'hz',
      sanitizer.bypassSecurityTrustResourceUrl('/hz-icons.svg')
    );
  });
}